import { Pipe, PipeTransform } from '@angular/core';
import { Client } from '../models/client';

@Pipe({ name: 'clientFilter' })
export class FilterClientPipe implements PipeTransform {
  /**
   * Filter clients by string
   * @param clients - clients to filter
   * @param searchText - search string
   * @returns filtered clients
   */
  transform(clients: Client[] | null, searchText: string): Client[] {
    if (!searchText) return clients!;

    const lowerCasedSearchText = searchText.toLowerCase();
    return clients!.filter(
      (client: Client) =>
        client.id.toLowerCase().includes(lowerCasedSearchText) ||
        client.name.toLowerCase().includes(lowerCasedSearchText),
    );
  }
}
